import React, { useEffect, useState } from "react";
import AdminLTE, { Inputs } from "adminlte-2-react";

import "react-phone-input-2/lib/style.css";

const { Select2 } = Inputs;

function SelectInput({ value, setValue, label, options, size="sm", labelPosition="above", disabled=false }) {
  return (
    <Select2
    disabled={disabled}
      labelPosition={labelPosition}
      label={label}
      value={value}
      options={options}
      onChange={(e) => setValue(e.target.value)}
      size={size}
    />
  );
}

export default SelectInput;
